export default {
  container: 'relative',
  alignRight: 'right-0',
  alignLeft: 'left-0',
  itemContainer: 'absolute top-[50px] rounded-lg shadow-[0_4px_42px_rgba(79,114,205,0.15)] z-10',
};
